export var FIELD_ERROR_REQUIRED = 'required';
export var FIELD_ERROR_UPLOADING = 'uploading';
export var FIELD_ERROR_SLUG = 'slug';
export var FIELD_ERROR_URL = 'url';
